import { Link } from '@tanstack/react-router';
import { CircleArrowLeft } from 'lucide-react';

import { EventListTable } from './event-list-table';

export const EventListPage = () => {
  return (
    <div className=''>
      <Link to='/dashboard' className='flex w-max items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>All Events</h2>
      </Link>
      <div className='mt-4 border-t pt-8'>
        <EventListTable />
      </div>
    </div>
  );
};
